import { bus } from '@/utils/bus';
import BaseModal from './baseModal';

class ErrBaseModal extends BaseModal {
  showMsg() {
    return bus.$message.error({
      showClose: this.showClose,
      message: this.mes.toString(),
      duration: this.duration,
    });
  }

  showNotifyMsg() {
    return bus.$notify.error({
      title: '错误',
      message: this.mes,
    });
  }
}
export default ErrBaseModal;
